import { parseObjectCreatedAt } from './dashboardPeriod';

export type HourlyObjectBucket = {
  hour: number;
  label: string;
  foundCount: number;
  claimedCount: number;
  deliveryCount: number;
};

function isInDeliveryStatus(status?: string): boolean {
  return status === 'to_ship' || status === 'in_transit';
}

function resolveClaimedAt(object: {
  claimedAt?: string | null;
  claimed_at?: string | null;
  status?: string;
}): Date | null {
  if (object.status !== 'claimed') return null;
  return parseObjectCreatedAt(object.claimedAt ?? object.claimed_at);
}

function resolveDeliveryAt(object: {
  updatedAt?: string | null;
  updated_at?: string | null;
  status?: string;
}): Date | null {
  if (!isInDeliveryStatus(object.status)) return null;
  return parseObjectCreatedAt(object.updatedAt ?? object.updated_at);
}

export function buildObjectsByHour(
  objects: {
    createdAt?: string;
    created_at?: string;
    claimedAt?: string | null;
    claimed_at?: string | null;
    updatedAt?: string | null;
    updated_at?: string | null;
    status?: string;
  }[],
): HourlyObjectBucket[] {
  const foundCounts = Array.from({ length: 24 }, () => 0);
  const claimedCounts = Array.from({ length: 24 }, () => 0);
  const deliveryCounts = Array.from({ length: 24 }, () => 0);

  for (const object of objects) {
    const created = parseObjectCreatedAt(object.createdAt ?? object.created_at);
    if (created) {
      foundCounts[created.getHours()] += 1;
    }

    const claimed = resolveClaimedAt(object);
    if (claimed) {
      claimedCounts[claimed.getHours()] += 1;
    }

    const delivery = resolveDeliveryAt(object);
    if (delivery) {
      deliveryCounts[delivery.getHours()] += 1;
    }
  }

  return foundCounts.map((foundCount, hour) => ({
    hour,
    label: `${String(hour).padStart(2, '0')}h`,
    foundCount,
    claimedCount: claimedCounts[hour],
    deliveryCount: deliveryCounts[hour],
  }));
}

export function isInDeliveryStatusForStats(status?: string): boolean {
  return isInDeliveryStatus(status);
}
